import React, { useEffect, useState } from 'react';
import { Dimensions, Platform, Pressable, StatusBar, View } from 'react-native'
import Modal from 'react-native-modal';

import PropTypes from 'prop-types';

import styles from './VFOverlay.Styles';
import { getProperOverlayTypeMemoized, OverlayTypes } from './VFOverlay.Utils';

import _Modal from 'react-native-modal'
import { Icon } from '@vfgroup-oneplatform/foundation/Components'

import { Colors, withTheme, LightThemeColors, getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes'
import { useTheme } from '../Themes'


function VFOverlay({ type, isVisible, onClosePress, ...props }) {
  const Overlay = getProperOverlayTypeMemoized(type);
  const [_isVisible, setIsVisible] = useState(isVisible);

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        setIsVisible(isVisible);
      }, 0);
    } else {
      setIsVisible(isVisible);
    }
  }, [isVisible]);

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    const themeImages = getThemeImages('light')
    const theme = useTheme()

    return (
      <_Modal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onSwipeComplete={onClosePress}
        onBackdropPress={onClosePress}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '730px',
            maxWidth: '730px',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '20px',
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          <View style={{ alignItems: 'flex-end', marginBottom: 20 }}>
            <Pressable onPress={() => onClosePress()} >
              <Icon
                name={themeImages.ic_close}
                size={25}
                resizeMode='contain'
              />
            </Pressable>
          </View>
          <Overlay {...props} />
        </View>
      </_Modal>
    )
  }

  return (
    <>
      {isVisible ? <StatusBar hidden /> : null}
      <Modal isVisible={_isVisible} style={styles.containerStyle}>
        <Overlay {...props} />
      </Modal>
    </>
  );
}

VFOverlay.propTypes = {
  type: PropTypes.oneOf(Object.values(OverlayTypes)),
  isVisible: PropTypes.bool.isRequired,
};

export default VFOverlay;
